<script setup>
defineProps({
  variant: { type: String, default: 'primary' }, /* primary | ghost | copper */
  size: { type: String, default: 'md' },         /* sm | md | lg */
  type: { type: String, default: 'button' },
  disabled: Boolean
})
</script>

<template>
  <button
    :type="type"
    :disabled="disabled"
    class="btn"
    :class="[`btn--${variant}`, `btn--${size}`]"
  >
    <slot />
  </button>
</template>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  border-radius: var(--r-sm);
  font-family: var(--font-display);
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  position: relative;
  transition: background var(--t-fast) var(--ease-road),
              color var(--t-fast) var(--ease-road),
              border-color var(--t-fast) var(--ease-road),
              transform var(--t-fast) var(--ease-road),
              box-shadow var(--t-fast) var(--ease-road);
  border: 1px solid transparent;
}
.btn:disabled { opacity: 0.4; cursor: not-allowed; }
.btn:not(:disabled):hover { transform: translateY(-1px); }
.btn:not(:disabled):active { transform: translateY(0); }
.btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--bg), 0 0 0 4px var(--gold);
}

.btn--sm { padding: 8px 14px;  font-size: var(--fs-12); }
.btn--md { padding: 12px 22px; font-size: var(--fs-14); }
.btn--lg { padding: 16px 32px; font-size: var(--fs-18); }

.btn--primary {
  background: var(--gold);
  color: var(--ink-inverse);
  border-color: var(--gold);
}
.btn--primary:not(:disabled):hover {
  background: var(--gold-deep);
  border-color: var(--gold-deep);
}

.btn--copper {
  background: var(--copper);
  color: var(--ink);
  border-color: var(--copper);
}
.btn--copper:not(:disabled):hover {
  background: var(--copper-deep);
  border-color: var(--copper-deep);
}

.btn--ghost {
  background: transparent;
  color: var(--ink);
  border-color: var(--ash-strong);
}
.btn--ghost:not(:disabled):hover {
  border-color: var(--gold);
  color: var(--gold);
}
</style>
